"use es6";

import { ArrayObservable } from './ArrayObservable';
export const of = ArrayObservable.of;